import { useNavigate } from "react-router-dom";
import React from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";

import Title from "../../../common/Title";
import BatchList from "../../../common/BatchList";

import useBatchListState from "../../../../hooks/useBatchListState";
import { __getPlanPurchaseBatches } from "../../../../api/sim";
import { PLAN_PURCHASE_OPERATIONS } from "../../../../utils/planPurchase";

const PlanPurchaseBatchList = ({ client, operation }) => {
  const nav = useNavigate();
  const config = PLAN_PURCHASE_OPERATIONS[operation];

  const {
    data,
    loading,
    metaData,
    response,
    statusCategories,
    handlePageChange,
    handlePageSizeChange,
    handleStatusCategoryChange,
  } = useBatchListState(__getPlanPurchaseBatches, {
    client,
    extraParams: { operation },
  });

  return (
    <Box sx={{ width: "100%" }}>
      <Title
        variant="h5"
        sx={{ textTransform: "capitalize" }}
        content={`${client ? client : ""} ${config.title}`}
        gutterBottom
      />

      {response ? (
        <>
          <Grid container justifyContent="flex-start" spacing={2}>
            <Grid item>
              <Stack spacing={2} direction="row">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => nav("form")}
                >
                  {config.title}
                </Button>
              </Stack>
            </Grid>
          </Grid>
          <BatchList
            data={data}
            loading={loading}
            meta={metaData}
            statusCategories={statusCategories}
            onStatusCategoryChange={handleStatusCategoryChange}
            handlePageChange={handlePageChange}
            handlePageSizeChange={handlePageSizeChange}
          />
        </>
      ) : (
        <Title content="Please wait..." variant="subtitle2" gutterBottom />
      )}
    </Box>
  );
};

export default PlanPurchaseBatchList;
